import { assignmentDecision, getAssignedValue, getConfigurationPrice, getProductPrice, getProductDescription } from '../util';
import { deflateModelVariables } from '../util';
import { getLanguages } from '../services';

const getConfiguration = ( item, prices, user ) => {
  const reConfig = user.properties.Action.toLowerCase() === "reconfig";
  const quantity = item.amount;
  const fromCart = true;
  const Configuration = {
    ActivityLocationId: getBALID(item, user),
    ActivityLocationName: user.properties["ActivityLocationName"],
    AccessoriesKMAT: getAccessoryKMAT(item),
    AccessoriesKmat: getAccessoryKMAT(item),
    ConfigurationId: reConfig ? user.properties.ConfigurationID : "",
    Currency: getCurrency(item, prices, user),
    Description: getProductDescription(item),
    KMAT: item.materialName||item.name,
    VariantKmat: item.materialName||item.name,
    NodeCID: getNodeCID(item, user),//user.properties["NodeCID"],
    Price: item.configuration ? getConfigurationPrice( item, prices, 'netPrice', fromCart ) : getProductPrice( item, prices, 'netPrice', fromCart  ),
    PriceType: user.properties["PriceType"],
    ProductType: user.properties["ProductType"],
    Quantity: quantity,
    Variant: item.aBBID,
    VariantId:item.aBBID,
    Supercode: item.superCode? item.superCode: null,
    Action: user.properties.Action,
    SelectionType: item.superCode ? 'ReadyAssembled':'SelfAssembly',
    addProduct: user.properties.addProduct
  }
  return Configuration;
};

const getAccessoryKMAT = item => {
  if(item.configuration){
    return item.configuration.materialKey
  }
  else if (item.materialName && item.materialName != item.aBBID){
    return item.materialName;
  }
  else{
    return "";
  }
}

const getCurrency = (item, prices, user) =>{
  return item.name && prices[item.name] && prices[item.name].rateUnit ?  prices[item.name].rateUnit : user.currency;
}
const getNodeCID = (item, user) =>{
  const nodeCID = item.properties.filter(p => p.name == "NodeCID");
  var nodeCIDValue;
  //nodeCIDValue = nodeCID.length > 0 ? nodeCID[0].value: user.properties["NodeCID"]
  nodeCIDValue = nodeCID.length > 0 ? nodeCID[0].value: item.nodeCID
  return nodeCIDValue;
}
const getBALID = (item, user) =>{
  const bALID = item.properties.filter(p => p.name == "BALID");
  const nodeBALIDValue = bALID.length > 0 ? bALID[0].value: (item.bALID ? item.bALID : user.properties["ActivityLocationId"]);
  return nodeBALIDValue;
}
const getConfiguratorId = (item, user) =>{
  let configuratorIdValue;
  let  configuratorId = user.properties.CallingApp === "Apttus" ? item.properties.filter(p => p.name == "ConfiguratorId") : item.properties.filter(p => p.name == "ELConfiguratorId");
  if(user.properties.CallingApp === "BOL"){
    configuratorIdValue  = user.properties["ConfiguratorID"];
  }
  else{
   configuratorIdValue = configuratorId.length > 0 ? configuratorId[0].value : user.properties["ConfiguratorID"];
  }
  return configuratorIdValue;
}

const getTechnicalParameter = ( item, prices, user, products ) => {
  var TechnicalParameters = [];
  var TempTechnicalParameters = [];
  var reConfig = user.properties.Action === "Reconfig" ? true : false;
  var amount = reConfig ? 1 : item.amount;
  for ( let param of item.assignments ) {
    TechnicalParameters.push( getVariantData( param ) );
  }
  if ( item.configuration ) {
    var accessories = getAccessories( item );
    for ( let accessory of accessories ) {
      if(products[accessory.assignedValue.name]){
      TempTechnicalParameters.push( getAccParamData( accessory, amount, prices,products ) );
      }
    }
  }
  //update with SAP BOM items
  if(item.configuration && item.configuration.bomComponents && item.configuration.bomComponents.length)
  {
    var missingBomItems = [];
    for(let count = 0; count < item.configuration.bomComponents.length; count++)
    {
      var missingBomItem = true;
      for(let tcount = 0;tcount < TempTechnicalParameters.length;tcount++){
        if((TempTechnicalParameters[tcount].isBom && TempTechnicalParameters[tcount].ParameterValue == item.configuration.bomComponents[count].component && missingBomItem )|| item.configuration.bomComponents[count].itemNumber >= 9000){
          missingBomItem = false;
        }
      }

      if(missingBomItem)
      {
        missingBomItems.push(item.configuration.bomComponents[count].component);
      }
    }

    for(let mcount = 0; mcount < missingBomItems.length; mcount++)
    {
      TempTechnicalParameters.push(getAccParamDataBOM(missingBomItems[mcount], amount, products, prices))
    }
    //Adding the Accessories for SAP Models in same order as they are added in Configuration Page 
    //to get an output from Notes and Documents in Apttus
    item.configuration.bomComponents.forEach(element => {
      TempTechnicalParameters.forEach(tempelement => {
        if(tempelement.ParameterName == element.component){
          TechnicalParameters.push(tempelement);
        }
      });
    });
  }
  else {
    //This part of the code adds the Accessories back to TechnicalParameters for Non SAP models
    if(TempTechnicalParameters.length != 0){
      TempTechnicalParameters.forEach(tempelement => {
        TechnicalParameters.push(tempelement);
      });
    }
  }

  return TechnicalParameters;
}

const getAccParamDataBOM = (bomItem, amount, products, prices) =>{
  const accParamDataBOM = {
    isBom: true,
    isVariant: false,
    ParameterCode: bomItem,
    ParameterDescription: getProductDescription(products[bomItem]),
    ParameterName: bomItem,
    ParameterValue: bomItem,
    ParameterValueDescription: getProductDescription(products[bomItem]),
    ParameterValuePrice: 0,//prices[bomItem] ? Number( prices[bomItem].listPrice * amount ) : 0,
    ParameterValueUnit: amount,
  }

  return accParamDataBOM;
}

const getVariantData = ( param ) => {
  const paramData = {
    isBom: false,
    isVariant: true,
    ParameterCode: param.value,
    ParameterDescription: param.name.split( '.' )[1],
    ParameterName: param.name.split( '.' )[1],
    ParameterValue: param.value,
    ParameterValueDescription: param.name.split( '.' )[1],
    ParameterValuePrice: 0,
    ParameterValueUnit: 0
  }
  return paramData;
}

const getAccParamData = ( accessory, amount, prices,products ) => {

  const accParamData = {
    isBom: true,
    isVariant: false,
    ParameterCode: accessory.properties["SAP"] ? accessory.properties["SAP"] : accessory.fullyQualifiedName,
    ParameterDescription: accessory.properties["EN"],
    ParameterName: accessory.properties["SAP"] && accessory.textValue ? accessory.textValue : accessory.assignedValue.name,
    ParameterValue: accessory.textValue,
    ParameterValueDescription: getProductDescription(products[accessory.assignedValue.name]),
    ParameterValuePrice: accessory.textValue ? ( prices[accessory.textValue] ? Number( prices[accessory.textValue].netPrice * amount ): 0 ) : ( prices[accessory.assignedValue.name] ? Number( prices[accessory.assignedValue.name].netPrice * amount ) : 0),
    ParameterValueUnit: amount,
  }
  return accParamData;
}

const getAccessoryPrice = (accessory, prices, amount) => {
  if(prices[accessory.textValue]){
    return accessory.textValue ? Number( prices[accessory.textValue].netPrice * amount ) : Number( prices[accessory.assignedValue.name].netPrice * amount );
  }
  else{
    return 0;
  }
}

const getAccessories = ( product ) => {
  const lang = getLanguages().first();
  const accessories = deflateModelVariables( product.configuration.model );
  const userAssignedAccessories = accessories.filter( accessory =>
    assignmentDecision( product.configuration.productModelType, lang )( accessory ) &&
    getAssignedValue( accessory ) !== product.configuration.product.name
  );
  return userAssignedAccessories;
}

const getTenderInformation = ( user ) => {
  const TenderInformation = {
    CallingApplication: user.properties.CallingApp,
    CartId: user.properties["CartID"],
    CountryCode: user.properties["CustomerCountry"],
    CustomerId: "",
    ItemPosition: user.properties["ItemPosition"],
    LineItemId: user.properties["LineItemID"],
    TenderId: user.properties["TenderID"],
    UserEmail: user.properties["UserEmailID"],
    UserName: user.properties["UserName"],
  };
  return TenderInformation;
}

const getProductConfigData = ( item, prices, user, products ) => {
  const productConfigData = {
    Configuration: getConfiguration( item, prices, user ),
    TenderInformation: getTenderInformation( user ),
    TechnicalParameters: getTechnicalParameter( item, prices, user, products ),
    ConfiguratorId: getConfiguratorId(item, user),
    ParamEditCopySaveFlag: user.properties["Action"]
  };
  return productConfigData;
}

export const getApttusCartInfo = ( cart, prices, user, products ) => {
  var productConfigData = [];
  for ( let item of cart ) {
    //adding Fixed and Mainpart products in to productConfigData
    if(item.additionalProducts){
    if(item.additionalProducts.length > 0){
      for(let additionalItem of item.additionalProducts){
        productConfigData.push( getProductConfigData( additionalItem, prices, user, products ) );
      }
    }
    else{
    //Adding single configuration
    productConfigData.push( getProductConfigData( item, prices, user, products ) );
    }
  }
  else{
    //Adding products without accessories
    productConfigData.push( getProductConfigData( item, prices, user, products ) );
  }
  }
  const CartInfo = {
    ProductConfigurationData: productConfigData
  };
  return CartInfo;
}

export const getApttusCartInfoForReconfig = ( prices, product, user, products ) => {
  var productConfigData = [];
  productConfigData.push( getProductConfigData( product, prices, user, products ) );
  const CartInfo = {
    ProductConfigurationData: productConfigData
  };
  return CartInfo;
}


